/*
 * Copyright 2021 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { cli } from 'cleye';
import { JsonObject } from '@backstage/types';
import { mergeConfigSchemas } from '@backstage/config-loader';
import type { JSONSchema7 as JSONSchema } from 'json-schema';
import openBrowser from 'react-dev-utils/openBrowser';
import chalk from 'chalk';
import { loadCliConfig } from '../lib/config';
import type { CliCommandContext } from '@backstage/cli-node';

const DOCS_URL = 'https://config.backstage.io';

export default async ({ args, info }: CliCommandContext) => {
  const {
    flags: { package: pkg },
  } = cli(
    {
      name: info.usage,
      booleanFlagNegation: true,
      flags: {
        package: {
          type: String,
          description:
            'Only include the schema that applies to the given package',
        },
      },
    },
    undefined,
    args,
  );

  const { schema: appSchemas } = await loadCliConfig({
    args: [],
    fromPackage: pkg,
    mockEnv: true,
  });

  const schema = mergeConfigSchemas(
    (appSchemas.serialize().schemas as JsonObject[]).map(
      _ => _.value as JSONSchema,
    ),
  );

  const url = `${DOCS_URL}#schema=${JSON.stringify(schema)}`;

  console.log();
  console.log(
    chalk.cyan(
      'Opening configuration reference documentation in your browser...',
    ),
  );
  console.log(`  ${chalk.cyan(url)}`);
  console.log();

  const opened = openBrowser(url);

  if (!opened) {
    console.log(
      chalk.yellow('⚠️  WARNING: Unable to open browser automatically.'),
    );
    console.log(chalk.yellow('Please open the URL manually in your browser.'));
  }
};
